import { FormInput } from "components";
import { useFormProvider } from "../../../../providers";

export function PhoneNumberComponent() {
  const { phoneNumber } = useFormProvider();

  return <FormInput.PhoneNumber value={phoneNumber} disabled />;
}
